<template>
  <div class="answer_result_container">
    <div class="result_box">
      <div class="portrait">
        <img :src="portrait" alt="">
      </div>
      <div class="score_box">
        <div class="congratulations">恭喜<span v-text="userInfo.nickName"></span>，完成本次答题</div>
        <div class="score_value"><span v-text="result.score"></span><span class="score_unit">分</span></div>
        <div class="">本次得分</div>
      </div>
      <div class="score_detail_box">
        <div class="score_detail_line">
          <div class="score_detail_item">
            <div class="detail_data data2"><span v-text="result.rightNumber"></span><span class="denominator">/</span><span class="denominator" v-text="result.wrongNumber+result.rightNumber"></span></div>
            <div class="detail_label">答对题数</div>
          </div>
          <div class="score_detail_item">
            <div class="detail_data data2"><span v-text="result.accuracy"></span></div>
            <div class="detail_label">本次胜率</div>
          </div>
        </div>
        <div class="score_detail_line">
          <div class="score_detail_item">
            <div class="detail_data"><span>00:00:00</span></div>
            <div class="detail_label">用时</div>
          </div>
          <div class="score_detail_item">
            <div class="detail_data"><span>+10</span></div>
            <div class="detail_label">本次积分</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "AnswerResult",
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState("app", ["userInfo"]),
    portrait() {
      if (!!this.userInfo && !!this.userInfo.resourceUrl && this.userInfo.resourceUrl.length > 0) {
        return this.userInfo.resourceUrl;
      } else {
        return require("@/assets/images/portrait.png");
      }
    },
  },
  data() {
    return {};
  },
  methods: {},
  created() { },
};
</script>
<style scoped lang="scss">
.answer_result_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background: #f6f6f6;
  overflow-x: hidden;
  overflow-y: auto;
  .result_box {
    position: relative;
    width: calc(100% - 30px);
    background: #fff;
    margin: 50px auto 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    box-shadow: 4px 3px 6px #ccc, -4px -3px 6px #ccc;
    .portrait {
      position: absolute;
      left: 50%;
      top: -30px;
      z-index: 9;
      width: 60px;
      height: 60px;
      margin-left: -30px;
      border-radius: 50%;
      img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 3px solid #fff;
      }
    }
    .score_box {
      padding: 50px 15px 35px;
      background: -webkit-linear-gradient(#277cff, #369fff);
      background: -o-linear-gradient(#277cff, #369fff);
      background: -moz-linear-gradient(#277cff, #369fff);
      background: linear-gradient(#277cff, #369fff);
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      text-align: center;
      color: #fff;
      .congratulations {
        line-height: 30px;
        font-size: 17px;
      }
      .score_value {
        line-height: 56px;
        color: #ffeb45;
        font-size: 40px;
        .score_unit {
          margin-left: 5px;
          font-size: 16px;
        }
      }
    }
    .score_detail_box {
      width: 100%;
      background-image: url(~@/assets/images/bg_line.png);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 90%;
      .score_detail_line {
        display: flex;
        padding: 15px 0;
        .score_detail_item {
          flex: 1;
          padding: 15px;
          .detail_data {
            line-height: 24px;
            text-align: center;
            color: #1a1a1a;
            font-size: 18px;
            font-weight: bold;
            &.data2 {
              line-height: 36px;
              font-size: 24px;
              .denominator {
                color: #6e6e6e;
                font-size: 16px;
                font-weight: normal;
              }
            }
          }
          .detail_label {
            line-height: 24px;
            text-align: center;
            color: #6e6e6e;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>